import { Component, OnInit, Renderer2, ElementRef, Inject, LOCALE_ID, Input } from '@angular/core';
import { AgreementShowModalService } from './modals/agreement-show/index';
import { forEach } from 'lodash-es';
import { languages } from './supported-languages';
import { APP_BASE_HREF } from '@angular/common';
import { SUPPORT_HOST } from '@schoolbelle/api/tokens';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input() backgroundColor = 'transparent';

  constructor(
    private agreement: AgreementShowModalService,
    private renderer:Renderer2,
    private elementRef:ElementRef,
    @Inject(LOCALE_ID) public localeId:string,
    @Inject(APP_BASE_HREF) private baseHref:string,
    @Inject(SUPPORT_HOST) public supportHost:string,    

  ) { 
  }

  self:HTMLElement;
  footerlist:NodeList;
  supportedLanguages = languages;
  ngOnInit() {
    this.self = this.elementRef.nativeElement.querySelector('footer');
    this.footerlist = document.querySelectorAll('footer');
    
    
    this.renderer.removeAttribute(this.self, 'hidden');
    forEach(this.footerlist, footer=>{
      if (this.self !== footer) {
        this.renderer.setAttribute(footer, 'hidden', '');
      }  
    });

  }

  ngOnDestroy () {
    forEach(this.footerlist, footer=>{
      if (this.self !== footer) this.renderer.removeAttribute(footer, 'hidden');
    });
  }
  show() {
    return this.agreement.open().subscribe();
  }

  changeLanguage (locale:string) {
    locale = locale.slice(0, 2);
    if (locale === this.localeId) return;
    
    
    localStorage.setItem('locale', locale);


    // '/en/main/home'
    let pathname_after_base_href = location.pathname;

    // '/en/main/home' => 'home'
    if (this.baseHref !== '/') pathname_after_base_href = pathname_after_base_href.replace(this.baseHref, '');
    
    // "/en/main/" => "/vi/main/"
    let newBaseHref = this.baseHref.replace(/\/[a-z]{2,2}\//, `/${locale}/`);
    if (newBaseHref === '/') newBaseHref = '';
    const redirectUrl = location.origin + newBaseHref + pathname_after_base_href;    



    console.debug('REDIRECT TO: ', redirectUrl);
    location.replace(redirectUrl);
  }
}
